export enum DaysOfWeek {
  'monday' = 0,
  'tuesday' = 1,
  'wednesday' = 2,
  'thursday' = 3,
  'friday' = 4,
  'saturday' = 5,
  'sunday' = 6,
}

export const WeekColors = ['magenta', 'orange', 'green', 'blue', 'purple', 'gold', 'red'];

export type ShowtimeSlot = {
  time: string; // h:mm a eg: 2:30 PM
  id: string;
  ticket: {
    adult: number;
    child: number;
  };
};
export type Showtime = {
  id: number;
  dayOfWeek: keyof typeof DaysOfWeek;
  active: boolean;
  times: ShowtimeSlot[];
};
